<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body text-center">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="my-0 font-bold mb-2"
          v-text="'Share with Membership Groups'"
        />
        <a
          v-if="!showCreateNewGroupSection"
          class="btn btn--border btn--sm"
          href="#"
          @click.prevent="showCreateNewGroupSection = true"
          v-text="'Create New Group'"
        />
        <a
          v-if="showCreateNewGroupSection"
          class="btn btn--border btn--sm"
          href="#"
          @click.prevent="showCreateNewGroupSection = false"
          v-text="'Choose Existing Group'"
        />
      </header>
      <div
        v-if="showCreateNewGroupSection"
        class="mt-6"
      >
        <input
          v-model="newMembershipGroupName"
          placeholder="New group name"
          type="text"
        >
        <select v-model="newMembershipTypeId">
          <option
            v-for="membershipGroupType in membershipGroupTypes"
            :key="membershipGroupType.id"
            :value="membershipGroupType.id"
            v-text="membershipGroupType.title"
          />
        </select>
        <footer class="text-center">
          <a
            href="#"
            class="btn btn--sm mb-2"
            @click.prevent="sendToNewGroup"
            v-text="'Create new group & send'"
          />
        </footer>
      </div>
      <div v-if="!showCreateNewGroupSection">
        <div class="flex justify-center items-baseline mt-4">
          <div class="input-group  w-2/3">
            <input
              v-model="search"
              placeholder="Search"
              type="text"
            >
          </div>
          <div class="text-xs pl-4 w-1/3">
            <a
              href="#"
              @click.prevent="selectAllGroups"
              v-text="'Select All'"
            />
            |
            <a
              href="#"
              @click.prevent="selectNoGroups"
              v-text="'Select None'"
            />
          </div>
        </div>
        <ul
          ref="membershipGroupContainer"
          class="scroll-checklist scroll-blue"
        >
          <li
            v-for="membershipGroup in membershipGroups"
            :key="membershipGroup.uuid"
          >
            <input
              :id="`group-${membershipGroup.uuid}`"
              v-model="selectedGroups"
              :value="membershipGroup.uuid"
              type="checkbox"
              :name="`group-${membershipGroup.uuid}`"
            >
            <label
              :for="`group-${membershipGroup.uuid}`"
              class="checkbox"
              v-text="membershipGroup.attributes.title"
            />
          </li>
        </ul>
        <footer class="text-center">
          <a
            class="btn btn--sm mb-2"
            href="#"
            @click.prevent="sendToExistingGroups"
            v-text="sendToExistingGroupsText"
          />
        </footer>
      </div>
    </div>
  </BaseModal>
</template>

<script type="text/babel">
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'SendToMembershipGroupsModal',
  props: {
    sharedItemMode: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showCreateNewGroupSection: false,
      newMembershipGroupName: '',
      newMembershipTypeId: 1,
      search: '',
      selectedGroups: [],
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      membershipGroups: state => state.membership.membershipGroups.data,
      pagination: state => state.membership.membershipGroups.meta.pagination,
      membershipGroupTypes: state => state.membership.membershipGroupTypes,
      show: state => state.document.SendToMembershipGroupsModal.open,
      resource: state => state.document.SendToMembershipGroupsModal.resource,
    }),
    sendToExistingGroupsText() {
      return this.selectedGroups.length === 1
        ? 'Share with 1 group'
        : `Share with ${this.selectedGroups.length} groups`
    },
  },
  watch: {
    show() {
      if (this.show) {
        if (!this.membershipGroups.length) {
          this.fetchMembershipGroups()
        }

        if (!this.membershipGroupTypes.length) {
          this.fetchMembershipGroupTypes()
            .then(() => {
              this.presetType()
            })
        }
      }
    },
    search: debounce(function () {
      this.fetchMembershipGroups({
        params: {
          query: this.search,
        },
      })
    }, 500),
  },
  mounted() {
    this.$refs.membershipGroupContainer.onscroll= () =>  {
      let container = this.$refs.membershipGroupContainer

      if(!this.isLoading && container.scrollTop + container.clientHeight  >  (container.scrollHeight -20) && this.pagination.current_page < this.pagination.total_pages ) {
        this.isLoading = true
        this.fetchMembershipGroups({
          params: {
            query: this.search,
            page: this.pagination.current_page + 1,
          },
        }).then(() => this.isLoading = false)
      }
    }
  },
  methods: {
    ...mapActions({
      fetchMembershipGroups: 'membershipGetMembershipGroups',
      fetchMembershipGroupTypes: 'membershipGetMembershipGroupTypes',
      createGroup: 'membershipCreateMembershipGroup',
      sendToGroups: 'documentSendResourceToGroups',
    }),
    presetType() {
      this.newMembershipTypeId = this.membershipGroupTypes[0].id
    },
    sendToExistingGroups() {
      this.sendToGroups({
        sharedItemMode: this.sharedItemMode,
        resource: this.resource,
        payload: {
          membershipGroupUuids: this.selectedGroups,
        },
      }).then(() => {
        this.$emit('resourceHasBeenSentToMembershipGroups')

        this.close()
      })
    },
    sendToNewGroup() {
      this.createGroup({
        title: this.newMembershipGroupName,
        type_id: this.newMembershipTypeId,
        self_assignable: false,
      }).then((response) => {
        this.selectedGroups = [response.data.uuid]

        this.sendToExistingGroups()
      })
    },
    selectAllGroups() {
      this.selectedGroups = _.map(this.membershipGroups, 'uuid')
    },
    selectNoGroups() {
      this.selectedGroups = []
    },
    close() {
      this.$store.commit('documentCloseSendToMembershipGroupsModal')

      // Delay to allow animation to complete before resetting.
      const vm = this

      setTimeout(function () {
        vm.showCreateNewGroupSection = false
        vm.newMembershipGroupName = ''
        vm.newMembershipTypeId = vm.membershipGroupTypes[0].id
        vm.search = ''
        vm.selectedGroups = []
      }, 2000)
    },
  },
}
</script>
